import { brand } from '../../theme/themePrimitives';
import BulkDealArchiveModal from '../deal/modal/bulk_archieve_modal';
import BulkDealDeleteModal from '../deal/modal/bulk_delete_modal';
import CustomDropdown from '../reusable/dropdown';
import { StageObject } from '../../params/redux/pipeline';
import { useState } from 'react';
import { AppDispatch, RootState } from '../../redux/store';
import { ArchiveOutlined, DeleteOutlineOutlined, HighlightOffOutlined } from '@mui/icons-material';
import { Box, Button, Checkbox, IconButton, Typography } from '@mui/material';
import { resetBulkSelection, selectAllDealsForBulkEdit, settingSelectedStageForBulkEdit } from '../../redux/slices/pipeline';
import { useDispatch, useSelector } from 'react-redux';

const SelectAllComponent = () => {
    const dispatch = useDispatch<AppDispatch>();
    const [showBulkDeleteModal, setShowBulkDeleteModal] = useState<boolean>(false);
    const [showBulkArchiveModal, setShowBulkArchiveModal] = useState<boolean>(false);
    const { selectedDeals, selectedPipeline, selectedStageForBulkEdit, loaders } = useSelector((state: RootState) => state.pipeline);
    const totalDeals = selectedPipeline?.pipeline_stages?.flatMap((stage: StageObject) => stage.deals).length || 0;

    /** Toggle all deals selection */
    const handleSelectAll = () => {
        dispatch(selectAllDealsForBulkEdit());
    };

    return (
        <Box display="flex" alignItems="center" justifyContent="space-between" pb={1} borderBottom="1px solid #ddd">
            {/* Select All Checkbox */}
            <Box display="flex" alignItems="center" gap={1}>
                <Button onClick={handleSelectAll} variant="outlined" startIcon={<Checkbox
                    checked={selectedDeals.length === totalDeals && totalDeals > 0}
                    disabled={totalDeals === 0 || loaders.isLoading}
                />}>Select All</Button>
                {selectedDeals.length === 0
                    ? (<Typography variant="body2" color="gray">
                        Select a deal to perform an action
                    </Typography>)
                    : (<Box display="flex" alignItems="center" color={brand[300]}>
                        <IconButton color="primary" size="small" disabled={loaders.isLoading} onClick={() => dispatch(resetBulkSelection())}>
                            <HighlightOffOutlined />
                        </IconButton>
                        <Typography variant="body1">{selectedDeals.length} Selected</Typography>
                    </Box>)}
            </Box>

            {/* If no deals are selected, show message */}
            {selectedDeals.length !== 0 && (
                <Box display="flex" alignItems="center" gap={2}>
                    <Typography variant="body2" whiteSpace="nowrap" color="gray">Move all deals:</Typography>
                    {/* Move to Stage Dropdown */}
                    <Box><CustomDropdown
                        options={selectedPipeline?.pipeline_stages
                            ? selectedPipeline.pipeline_stages.map((pipe: StageObject) => ({
                                label: pipe.stage_name,
                                value: pipe.id
                            }))
                            : []}
                        onChange={(e) => dispatch(settingSelectedStageForBulkEdit(Number(e.target.value)))}
                        placeholder="Select Stage"
                        error={false}
                        value={selectedStageForBulkEdit ? selectedStageForBulkEdit : ''}
                        disabled={loaders.isLoading}
                        sx={{
                            mb: 0
                        }}
                    /></Box>

                    {/* Bulk Actions */}
                    <Button variant="outlined" color="error" disabled={loaders.isLoading} startIcon={<DeleteOutlineOutlined />} onClick={() => setShowBulkDeleteModal(true)}>
                        Delete Selected
                    </Button>
                    <Button variant="outlined" color="primary" disabled={loaders.isLoading} startIcon={<ArchiveOutlined />} onClick={() => setShowBulkArchiveModal(true)}>
                        Archive Selected
                    </Button>
                </Box>
            )}
            {showBulkDeleteModal && <BulkDealDeleteModal open={showBulkDeleteModal} onClose={() => setShowBulkDeleteModal(false)} />}
            {showBulkArchiveModal && <BulkDealArchiveModal open={showBulkArchiveModal} onClose={() => setShowBulkArchiveModal(false)} />}
        </Box>
    );
};

export default SelectAllComponent;
